import { useI18n } from 'vue-i18n'
import { ref, inject } from 'vue'

export default function () {
  const i18n = useI18n({ useScope: 'global' })
  const cookies = inject('vue-cookie')
  const profile = ref(cookies.getCookie('profile'))
  
  const getInfoBox = () => {
    let key = profile.value.country.toUpperCase()
    return i18n.t(
      `auto_investment.setup.promoter_fiscal_country.info_box.${key}`
    )
  }

  const buildAutoInvestmentsSteps = () => {
    let steps = i18n.tm('auto_investment.steps')
    let showFiscalCountry = false
    
    return {
      showFiscalCountry,
      steps,
    }

  }

  return {
    buildAutoInvestmentsSteps,
    getInfoBox
  }
}
